export default "__VITE_ASSET__2b7946e4__"